<mat-dialog-content class="content-dialog">
  <div class="dialog-container">
    <div class="dialog-header d-flex">
      <div class="header-text">
        Add {{data.candidateIds.length === 1 ? '' : data.candidateIds.length}}
        candidate{{data.candidateIds.length > 1 ? 's' : ''}} to talent pool
      </div>
      <button
        mat-flat-button
        class="md circle"
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div
      class="dialog-content"
      [formGroup]="form"
    >
      <div class="row search-input">
        <common-mojo-tag
          class="secondary-tag"
          [(tags)]="talentPoolTags"
          [allowCreate]="true"
          [hasOptionSecondRow]="true"
          [autocompleteService]="talentPoolService"
          inputLabel="Search for talent pool"
          color="accent"
        ></common-mojo-tag>
      </div>
      <div class="row buttons">
        <button
          (click)="closeDialog()"
          mat-button
          color="accent"
        >Cancel</button>
        <button
          mat-raised-button
          color="primary"
          class="md"
          (click)="onSubmit()"
          [disabled]="talentPoolTags.length === 0"
        >SAVE</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
